import React, { Component } from "react";
import { Table } from "react-bootstrap";
import SvgIcon from "react-icons-kit";
import { eye } from "react-icons-kit/icomoon/eye";
import { pencil } from "react-icons-kit/icomoon/pencil";
import { bin } from "react-icons-kit/icomoon/bin";
import { priceTag } from "react-icons-kit/icomoon/priceTag";
import swal from "sweetalert";
import "sweetalert/dist/sweetalert.css";
import { translate } from "react-i18next";
import Moment from "react-moment";
import ModalVitalSigns from "../../toolbar/components/ModalVitalSigns";
import ModalBiometrics from "../../toolbar/components/ModalBiometrics";
import ModalSocial from "../../toolbar/components/ModalSocial";
import ModalGrupoRH from "./ModalGrupoRH";
import ModalPreRegisterIncident from "./ModalPreRegisterIncident";
import ModalIncidents from "./ModalIncidents";
import FloatingActionButton from "material-ui/FloatingActionButton";
import ContentAdd from "material-ui/svg-icons/content/add";
import ContentRemove from "material-ui/svg-icons/content/remove";
import { droplet } from "react-icons-kit/icomoon/droplet";
import ModalExtraction from "./ModalExtraction";
import ModalViewInformation from "./ModalViewInformation";
import { volumeHigh } from "react-icons-kit/icomoon/volumeHigh";
import { volumeMute2 } from "react-icons-kit/icomoon/volumeMute2";
import Notifications, { notify } from "react-notify-toast";
import ModalPrintLabel from "../../generics/ModalPrintLabel";
import { fileText } from "react-icons-kit/icomoon/fileText";
import WaitingModal from "../../generics/WaitingModal";
import { clipboard } from "react-icons-kit/icomoon/clipboard";
import { printer } from "react-icons-kit/icomoon/printer";
import ModalSingleValidation from "../../validation_donation/components/ModalSingleValidation";
import moment from "moment";

import IconBio from "../../../assets/icons/biometric";
import IconEx from "../../../assets/icons/extraction";
import IconHC from "../../../assets/icons/HC";
import IconSV from "../../../assets/icons/sv";
import IconInc from "../../../assets/icons/incident";

import { ic_assignment_ind } from "react-icons-kit/md/ic_assignment_ind";

import { print } from "react-icons-kit/fa/print";
import { cross } from "react-icons-kit/icomoon/cross";
import { callerActionHistoryVitalSignsTaken } from "../../../libs/services";
import { arrayInsert } from "redux-form";

var Config = require("../../../config");

class TableOffers extends Component {
  constructor(props, context) {
    super(props, context);

    this.deleteMsg = this.deleteMsg.bind(this);
    this.showColumn = this.showColumn.bind(this);
    this.printDonationTicket = this.printDonationTicket.bind(this);
    this.refreshDonor = this.refreshDonor.bind(this);
    this.print_time_record = this.print_time_record.bind(this);
    this.print_concent = this.print_concent.bind(this);
    this.printAferesis = this.printAferesis.bind(this);
    this.directPrint = this.directPrint.bind(this);
    this.openConfirmVitalSigns = this.openConfirmVitalSigns.bind(this);
    this.openModalLabel = this.openModalLabel.bind(this);
    this.printDocument = this.printDocument.bind(this);
    var aux_date = new Date();

    this.state = {
      columns: [],
      today:
        aux_date.getFullYear() +
        "-" +
        ("0" + (aux_date.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + aux_date.getDate()).slice(-2),
      task_vital_signs: JSON.parse(sessionStorage.getItem("task_vital_signs")),
      task_biometrics: JSON.parse(sessionStorage.getItem("task_biometrics")),
      task_clinic_history: JSON.parse(
        sessionStorage.getItem("task_clinic_history")
      ),
      task_register: JSON.parse(sessionStorage.getItem("task_register")),
      task_extraction: JSON.parse(sessionStorage.getItem("task_extraction")),
      don_hue_dig: {},
      don_hue_ext: {},
      don_orgn_comp_don: {},
      don_hc_hue_dig: {},
      search: "",
      don_sv_hue_dig: {},
      don_bh_hue_dig: {},
      print_tickets: {},
      print_donation_receipt: {},
    };
  }

  componentDidMount() {
    this.props.onRef(this);

    this.props.socket.onerror = (event) => {
    };

    this.props.socket.onmessage = (event) => {
      var res = JSON.parse(event.data);
      if (res.Error === "No hay impresora configurada para imprimir")
        swal("¡Error!", res.Error, "error");
    };
    
    this.setState({
      task_vital_signs: JSON.parse(sessionStorage.getItem("task_vital_signs")),
      task_biometrics: JSON.parse(sessionStorage.getItem("task_biometrics")),
      task_clinic_history: JSON.parse(
        sessionStorage.getItem("task_clinic_history")
      ),
      task_register: JSON.parse(sessionStorage.getItem("task_register")),
      task_extraction: JSON.parse(sessionStorage.getItem("task_extraction")),
      search: this.props.match.url.replace("/", ""),
    });

    var search = this.props.match.url.replace("/", "");
    
    if (search === "search_donor") {
      search = "DONORS_SEARCH";
    }

    if (this.props.state.show_promotion) {
      search = "CAMPAINGS";
    }

    fetch(
      Config.default.apiGateway.URL +
        "list_show?option=list_key&search=" +
        search,
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        if (response !== undefined) {
          this.setState({ columns: response });
        }
      });

    //variable huella
    //Criterio funcional,cambiar lugar de colecta
    fetch(
      Config.default.apiGateway.URL + "functional_criterion?code=don_hue_dig",
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          don_hue_dig: response,
        });
      });
    
    fetch(
      Config.default.apiGateway.URL +
        "functional_criterion?code=print_donation_receipt",
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          print_donation_receipt: response,
        });
      });
    
    fetch(
      Config.default.apiGateway.URL + "functional_criterion?code=DON_HUE_EXT",
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          don_hue_ext: response,
        });
      });
    
    fetch(
      Config.default.apiGateway.URL +
        "functional_criterion?code=DON_SV_HUE_DIG",
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          don_sv_hue_dig: response,
        });
      });
    
    fetch(
      Config.default.apiGateway.URL +
        "functional_criterion?code=DON_BH_HUE_DIG",
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          don_bh_hue_dig: response,
        });
      });
    
    fetch(
      Config.default.apiGateway.URL +
        "functional_criterion?code=DON_HC_HUE_DIG",
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          don_hc_hue_dig: response,
        });
      });

    
    //Criterio funcional,cambiar lugar de colecta
    fetch(
      Config.default.apiGateway.URL +
        "functional_criterion?code=lab_preview_print",
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          preview_print: response,
        });
      });

    //Criterio funcional,cambiar lugar de colecta
    fetch(
      Config.default.apiGateway.URL +
        "functional_criterion?code=DON_ORGN_COMP_DON",
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          don_orgn_comp_don: response,
        });
      });

    //Criterio funcional,imprimir tickets automaticos en bh
    fetch(
      Config.default.apiGateway.URL + "functional_criterion?code=PRINT_TICKETS",
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    )
      .then((response) => response.json())
      .then((response) => {
        this.setState({
          print_tickets: response,
        });
      });
  }

  componentWillUnmount() {
    this.props.onRef(null);
  }

  //Abrir modal para detalles del registro
  openModalDetails(item) {
    // this.modal.handleShow(item);
  }

  //Mensaje de alerta, confirmar eliminacion
  deleteMsg(item, props) {
    var id = item.offers_id;

    swal(
      {
        title: "¿Está seguro?",
        text: "¿Desea eliminar este registro?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "¡Si, Eliminar!",
        cancelButtonText: "¡No, Cancelar!",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      function (isConfirm) {
        if (isConfirm) {
          fetch(Config.default.apiGateway.URL + "offers/" + id, {
            method: "delete",
            headers: new Headers({
              Authorization: "Bearer " + sessionStorage.getItem("token"),
              Accept: "application/json",
              "Content-Type": "application/json",
            }),
          })
            .then((res) => {
              if (res.ok) {
                return res.json();
              } else {
                res.text().then(function (result) {
                  swal("¡Error!", result, "error");
                });
              }
            })
            .then((res) => {
              if (res !== undefined) {
                swal("Buen Trabajo", "Registro Eliminado", "success");
                props.refresh();
              }
            });
        }
      }
    );
  }

  openModalHC(e, offer, caller) {
    e.preventDefault();

    if (this.props.task_clinic_history.read && caller === null) {
      this.props.history.push(
        "/clinic_history/" + offer.offers_id + "/" + offer.donor_id
      );
    } else if (
      this.props.task_clinic_history.read &&
      (caller.machine_ip === null ||
        caller.machine_ip === sessionStorage.getItem("ip"))
    ) {
      this.props.history.push(
        "/clinic_history/" + offer.offers_id + "/" + offer.donor_id
      );
    }
  }

  openModalVitalSigns(e, offers_id, donor_id, caller, item) {
    e.preventDefault();
      const isExtractionComplete = item.ex_status === "COMPLETE";

    if (this.props.task_vital_signs.read && caller === null) {
      this.modal_vital_signs.handleShow(offers_id, donor_id, "", isExtractionComplete);
    } else if (
      this.props.task_vital_signs.read &&
      (caller.machine_ip === null ||
        caller.machine_ip === sessionStorage.getItem("ip"))
    ) {
      this.modal_vital_signs.handleShow(offers_id, donor_id, caller.id, isExtractionComplete);
    }
  }

  openModalSocial(e, offers_id, donor_id, caller, donor_name) {
    e.preventDefault();

    // if(this.props.task_vital_signs.read && caller ===null){
    this.modal_social.handleShow(offers_id, donor_id, "", donor_name);
    // }else if(this.props.task_vital_signs.read && (caller.machine_ip === null || caller.machine_ip === sessionStorage.getItem("ip"))){

    //   this.modal_captura_muestra.handleShow(offers_id,donor_id, caller.id);
    // }
  }

  openModalGrupoRH(
    e,
    offer,
    group_test_id,
    group_rh,
    caller,
    type = "initial"
  ) {
    e.preventDefault();

    if (caller === null) {
      this.modal_grupo_rh.handleShow(
        offer.donor_id,
        offer.offers_id,
        group_test_id,
        group_rh,
        "",
        type
      );
    } else {
      this.modal_grupo_rh.handleShow(
        offer.donor_id,
        offer.offers_id,
        group_test_id,
        group_rh,
        caller.id,
        type
      );
    } /*if(caller === null || caller.machine_name.indexOf(sessionStorage.getItem("machine_name")) !== -1){
      
    }*/
  }

  openModalBiometrics(e, offers_id, donor_id, caller, item) {
      const isExtractionComplete = item.ex_status === "COMPLETE";


    e.preventDefault();
    if (this.props.task_biometrics.read && caller === null) {
      this.modal_biometrics.handleShow(offers_id, donor_id, "", isExtractionComplete);
    } else if (
      this.props.task_biometrics.read &&
      (caller.machine_ip === null ||
        caller.machine_ip === sessionStorage.getItem("ip"))
    ) {
      this.modal_biometrics.handleShow(offers_id, donor_id, caller.id, isExtractionComplete);
    }
  }

  goToEX(e, offer, caller, hc_color, rejected) {
    e.preventDefault();
    var extraction_incident_id = offer.extraction_incident_id;
    if (
      extraction_incident_id === null ||
      extraction_incident_id === undefined
    ) {
      extraction_incident_id = 0;
    }

    var promotion = this.props.state.show_promotion ? "/promotion" : "";

    if (offer.ExternalType) {
      if (caller === null) {
        this.props.history.push(
          promotion +
            "/extractions/new/" +
            offer.offers_id +
            "/" +
            offer.donor_id +
            "/" +
            offer.donation_id +
            "/" +
            extraction_incident_id +
            "/0/0"
        );
      } else {
        this.props.history.push(
          promotion +
            "/extractions/new/" +
            offer.offers_id +
            "/" +
            offer.donor_id +
            "/" +
            offer.donation_id +
            "/" +
            extraction_incident_id +
            "/" +
            caller.id +
            "/0"
        );
      }
    } else {
      if (
        this.props.task_extraction.create &&
        caller === null &&
        hc_color !== "" &&
        rejected === "ACCEPT"
      ) {
        this.props.history.push(
          promotion +
            "/extractions/new/" +
            offer.offers_id +
            "/" +
            offer.donor_id +
            "/" +
            offer.donation_id +
            "/" +
            extraction_incident_id +
            "/0/0"
        );
      } else if (this.props.task_extraction.create && caller !== null) {
        if (
          (caller.machine_ip === null ||
            caller.machine_ip === sessionStorage.getItem("ip")) &&
          hc_color !== "" &&
          rejected === "ACCEPT"
        ) {
          this.props.history.push(
            promotion +
              "/extractions/new/" +
              offer.offers_id +
              "/" +
              offer.donor_id +
              "/" +
              offer.donation_id +
              "/" +
              extraction_incident_id +
              "/" +
              caller.id +
              "/0"
          );
        }
      }
    }
  }

  openModalExtraction(e, offer, caller, hc_color, rejected) {
    e.preventDefault();
    if (
      (this.props.task_extraction.create || caller === null) &&
      hc_color !== "" &&
      rejected === "ACCEPT"
    ) {
      this.modal_extractions.handleShow(
        offer.donor_id,
        offer.offers_id,
        offer.group_test_id,
        offer.group_rh,
        "ext"
      );
    } else if (
      (this.props.task_extraction.create || caller.machine_ip !== null) &&
      hc_color !== "" &&
      rejected === "ACCEPT"
    ) {
      this.modal_extractions.handleShow(
        offer.donor_id,
        offer.offers_id,
        offer.group_test_id,
        offer.group_rh,
        "ext"
      );
    }
  }

  openModalHueBH(e, offer, caller, hc_color, rejected) {
    e.preventDefault();
    this.modal_extractions.handleShow(
      offer.donor_id,
      offer.offers_id,
      offer.group_test_id,
      offer.group_rh,
      "bh",
      this.state.print_tickets.value
    );
  }

  openModalHueSV(e, offer, caller, hc_color, rejected) {
    e.preventDefault();

    this.modal_extractions.handleShow(
      offer.donor_id,
      offer.offers_id,
      offer.group_test_id,
      offer.group_rh,
      "sv"
    );
  }

  openModalHueHC(e, offer, caller, hc_color, rejected) {
    e.preventDefault();

    this.modal_extractions.handleShow(
      offer.donor_id,
      offer.offers_id,
      offer.group_test_id,
      offer.group_rh,
      "hc"
    );
  }

  openModalIncidents(e, item) {
    e.preventDefault();
    var extraction_incident_id = item.extraction_incident_id;
    if (
      extraction_incident_id === null ||
      extraction_incident_id === undefined
    ) {
      extraction_incident_id = 0;
    }

    if (item.caller === null) {
      //Si no esta siendo atendido por ningun doctor
      this.modal_incidents.handleShow(
        item.offers_id,
        extraction_incident_id,
        ""
      );
    } else if (
      item.caller.machine_ip === null ||
      item.caller.machine_ip === sessionStorage.getItem("ip")
    ) {
      //Si no esta siendo atendido por ningun doctor
      this.modal_incidents.handleShow(
        item.offers_id,
        extraction_incident_id,
        item.caller.id
      );
    }
  }

  openModalViewInformation(e, offer, caller) {
    e.preventDefault();
    this.modal_view_information.handleShow(offer.offers_id, caller.id);
  }

  showColumn(column_name) {
    var i = 0;
    if (this.props.columns.length > 0) {
      for (i = 0; i < this.props.columns.length; i++) {
        if (this.props.columns[i] === column_name) {
          return false;
        }
      }
    } else {
      for (i = 0; i < this.state.columns.length; i++) {
        if (this.state.columns[i] === column_name) {
          return false;
        }
      }
    }

    return true;
  }

  preRegisterIncident(e, caller) {
    e.preventDefault();
    this.modal_incident.handleShow(caller);
  }

  openRegister(e, caller) {
    e.preventDefault();
    this.props.history.push("offers/new/" + caller.id);
  }

  filter(row) {
    var res = true;
    if (row.offer !== null) {
      //Si tiene registro de donacion

      var name = row.donor_name;

      row.extraction_name =
        row.extraction_name !== null ? row.extraction_name : "";
      row.donation_name = row.donation_name !== null ? row.donation_name : "";
      row.timestamp_hour =
        row.timestamp_hour !== null ? row.timestamp_hour : "";
      row.donation_number =
        row.donation_number !== null ? row.donation_number.toString() : "";
      row.donor_number =
        row.donor_number !== null ? row.donor_number.toString() : "";

      if (
        //Buscar en offer
        name.indexOf(this.props.filterText.toUpperCase()) !== -1 ||
        row.extraction_name.indexOf(this.props.filterText.toUpperCase()) !==
          -1 ||
        row.donation_name.indexOf(this.props.filterText.toUpperCase()) !== -1 ||
        row.donation_number.indexOf(this.props.filterText.toUpperCase()) !==
          -1 ||
        row.donor_number.indexOf(this.props.filterText) !== -1
      ) {
        res = true;
      } else {
        if (row.caller !== null) {
          //Si tiene llamador
          if (
            row.caller.record_number
              .toString()
              .indexOf(this.props.filterText.toUpperCase()) !== -1 ||
            row.caller.status.indexOf(this.props.filterText.toUpperCase()) !==
              -1
          ) {
            res = true;
          } else {
            res = false;
          }
        } else {
          res = false;
        }
      }
    } else {
      //Si tiene solo llamador
      if (
        row.caller.record_number
          .toString()
          .indexOf(this.props.filterText.toUpperCase()) !== -1 ||
        row.caller.status.indexOf(this.props.filterText.toUpperCase()) !== -1
      ) {
        res = true;
      } else {
        res = false;
      }
    }

    return res;
  }

  releaseCaller(caller_id) {
    fetch(
      Config.default.apiGateway.URL +
        "caller_actions_history?id=" +
        caller_id +
        "&ip=" +
        sessionStorage.getItem("ip") +
        "&section=null&option=release",
      {
        method: "PUT", // or 'PUT'
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        }),
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
      })
      .catch((error) => console.error("Error:", error))
      .then((response) => {
        notify.show("Registro Removido de Llamador", "success");
        this.props.refresh();
      });
  }

  caller(caller_id) {
    //Identificar de que area es activado el llamador
    var section = null;
    switch (this.props.match.path) {
      case "/register":
        section = "REGISTRO";
        break;
      case "/vital_signs":
        section = "SIGNOS VITALES";
        break;
      case "/biometrics":
        section = "BIOMETRÍA HEMÁTICA";
        break;
      case "/clinic_history":
        section = "HISTORIA CLÍNICA";
        break;
      case "/extractions":
        section = "EXTRACCIÓN";
        break;
      case "/social":
        section = "REGISTRO";
        break;
      default:
        section = "--------";
    }
    fetch(
      Config.default.apiGateway.URL +
        "caller_actions_history?id=" +
        caller_id +
        "&ip=" +
        sessionStorage.getItem("ip") +
        "&section=" +
        section +
        "&option=lock",
      {
        method: "PUT", // or 'PUT'
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json;charset=UTF-8",
        }),
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
      })
      .catch((error) => console.error("Error:", error))
      .then((response) => {
        notify.show("Registro Agregado a Llamador", "success");
        this.props.refresh();
      });
  }

  openViewDetails(e, offer, caller) {
    e.preventDefault();

    if (caller === null) {
      this.props.history.push("offers/0/" + offer.offers_id);
    } else {
      this.props.history.push("offers/" + caller.id + "/" + caller.offers_id);
    }
  }

  openModalLabel(type, id, extraction, print) {
    this.modal_print_label.handleShow(
      type,
      id,
      extraction,
      print,
      this.state.preview_print,
      "offers"
    );
  }

  async printDonationTicket(e, offers_id, donation_ticket, donation_number) {
    e.preventDefault();
    if (this.state.print_donation_receipt.value == "YES") {
      if (donation_number === "") {
        swal("Error", "no se a generado numero de donación", "error");
        return;
      } else {
        this.waiting_modal.handleShow("Imprimiendo...");

        var obj = {};
        var url = "";
        obj.health_facilities_id = parseInt(
          sessionStorage.getItem("health_facilities_id"),
          10
        );
        obj.id = offers_id;
        obj.nEtiqueta = [];

        if (this.state.don_orgn_comp_don.value === "ETIQUETA") {
          obj.file_type = "valid_donation";
          url = "labelsEditor";

          fetch(Config.default.apiGateway.URL + url, {
            method: "post",
            body: JSON.stringify(obj),
            responseType: "blob", //Force to receive data in a Blob Format
            headers: new Headers({
              Authorization: "Bearer " + sessionStorage.getItem("token"),
              "Content-Type": "application/json",
            }),
          })
            .then((res) => {
              this.waiting_modal.handleClose();
              if (res.ok) {
                return res.blob();
              } else {
                res.text().then(function (result) {
                  swal("¡Error!", result, "error");
                  return;
                });
              }
            })
            .then((response) => {
              if (response !== undefined) {
                if (this.state.preview_print.value === "NO") {
                  //PREVIEW
                  var fileURL = URL.createObjectURL(response);
                  window.open(fileURL);
                } else {
                  this.directPrint(response, "document_register");
                }
              }
            });
        } else {
          url = "html_templates/print_document";
          obj.file_type = "ticket_valid_donor";

          var type = await this.props.getDocumentType(obj.file_type);

          var document;
          if (type.print_type === "template") {
            document = await this.props.printDocumentTemplate(
              obj,
              type.print_automatically
            );
          } else if (type.print_type === "external") {
            document = await this.props.printDocumentExternal(
              obj,
              type.print_automatically
            );
          }

          if (document !== undefined) {
            this.waiting_modal.handleClose();
            this.setState({ show: false });
          } else {
            this.waiting_modal.handleClose();
          }
        }
      }
    } else {
      this.waiting_modal.handleShow("Imprimiendo...");

      var obj = {};
      var url = "";
      obj.health_facilities_id = parseInt(
        sessionStorage.getItem("health_facilities_id"),
        10
      );
      obj.id = offers_id;
      obj.nEtiqueta = [];

      if (this.state.don_orgn_comp_don.value === "ETIQUETA") {
        obj.file_type = "valid_donation";
        url = "labelsEditor";

        fetch(Config.default.apiGateway.URL + url, {
          method: "post",
          body: JSON.stringify(obj),
          responseType: "blob", //Force to receive data in a Blob Format
          headers: new Headers({
            Authorization: "Bearer " + sessionStorage.getItem("token"),
            "Content-Type": "application/json",
          }),
        })
          .then((res) => {
            this.waiting_modal.handleClose();
            if (res.ok) {
              return res.blob();
            } else {
              res.text().then(function (result) {
                swal("¡Error!", result, "error");
                return;
              });
            }
          })
          .then((response) => {
            if (response !== undefined) {
              if (this.state.preview_print.value === "NO") {
                //PREVIEW
                var fileURL = URL.createObjectURL(response);
                window.open(fileURL);
              } else {
                this.directPrint(response, "document_register");
              }
            }
          });
      } else {
        url = "html_templates/print_document";
        obj.file_type = "ticket_valid_donor";

        var type = await this.props.getDocumentType(obj.file_type);

        var document;
        if (type.print_type === "template") {
          document = await this.props.printDocumentTemplate(
            obj,
            type.print_automatically
          );
        } else if (type.print_type === "external") {
          document = await this.props.printDocumentExternal(
            obj,
            type.print_automatically
          );
        }

        if (document !== undefined) {
          this.waiting_modal.handleClose();
          this.setState({ show: false });
        } else {
          this.waiting_modal.handleClose();
        }
      }
    }
  }

  async printDocument(e, offers_id) {
    e.preventDefault();
    this.waiting_modal.handleShow("Imprimiendo...");

    var obj = {};
    var url = "";
    obj.health_facilities_id = parseInt(
      sessionStorage.getItem("health_facilities_id"),
      10
    );
    obj.id = offers_id;
    obj.nEtiqueta = [];

    url = "html_templates/print_document";
    obj.file_type = "REFERENCE_DONORS";

    var type = await this.props.getDocumentType(obj.file_type);

    var document;
    if (type.print_type === "template") {
      document = await this.props.printDocumentTemplate(
        obj,
        type.print_automatically
      );
    } else if (type.print_type === "external") {
      document = await this.props.printDocumentExternal(
        obj,
        type.print_automatically
      );
    }

    if (document !== undefined) {
      this.waiting_modal.handleClose();
      this.setState({ show: false });
    } else {
      this.waiting_modal.handleClose();
    }
  }

  directPrint(response, label_type) {
    //PRINTER
    var reader = new FileReader();
    reader.readAsDataURL(response);
    reader.onloadend = () => {
      var base64data = reader.result;
      var aux = base64data.split(",");

      this.props.socket.send(
        '{"Operacion":"print", "Type":"' +
          label_type +
          '", "File": "' +
          aux[1] +
          '"}'
      );
    };
  }

  editRegister(e, item) {
    if (this.props.state.show_promotion) {
      this.props.history.push(
        "/promotion/offers/edit/" +
          item.offers_id +
          "/" +
          item.donor_id +
          "/0/" +
          item.extraction_incident_id +
          "/0/0"
      );
    } else {
      this.props.history.push(
        "/offers/edit/" +
          item.offers_id +
          "/" +
          item.donor_id +
          "/0/" +
          item.extraction_incident_id +
          "/0/0"
      );
    }
  }

  singleValidation(e, section, item) {
    e.preventDefault();
    this.single_validation.handleShow(
      item.donation_id,
      section.lab_section_id,
      section.lab_section_name,
      item.samples_id
    );
  }

  refreshDonor() {
    this.props.refresh(this.props.offers.res[0].donor_id);
  }

  laboratory_print(e, item) {
    e.preventDefault();

    fetch(
      Config.default.apiGateway.URL +
        "html_templates?health_facilities_id=" +
        sessionStorage.getItem("health_facilities_id") +
        "&file_type=area_laboratory&extraction_type=",
      {
        method: "get",
        headers: new Headers({
          Authorization: "Bearer " + sessionStorage.getItem("token"),
          Accept: "application/json",
          "Content-Type": "application/json",
        }),
      }
    )
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          res.text().then(function (result) {
            swal("¡Error", result, "error");
          });
        }
      })
      .then(async (response) => {
        if (response.res === 0) {
          swal(
            "¡Error!",
            "No se ha definido ningún formato de impresión",
            "error"
          );
        } else {
          this.props.waiting.handleShow("Imprimiendo...");

          var obj = {};
          obj.health_facilities_id = parseInt(
            sessionStorage.getItem("health_facilities_id"),
            10
          );
          obj.id = item.donation_id;
          obj.file_type = "area_laboratory";
          obj.nEtiqueta = [0];

          var type = await this.props.getDocumentType(obj.file_type);

          var document;
          if (type.print_type === "template") {
            document = await this.props.printDocumentTemplate(
              obj,
              type.print_automatically
            );
          } else if (type.print_type === "external") {
            document = await this.props.printDocumentExternal(
              obj,
              type.print_automatically
            );
          }

          this.props.waiting.handleClose();
        }
      });
  }

  async print_time_record(e, item) {
    e.preventDefault();
    this.props.waiting.handleShow("Imprimiendo...");

    var obj = {};
    obj.health_facilities_id = parseInt(
      sessionStorage.getItem("health_facilities_id"),
      10
    );
    obj.id = item.offers_id;
    obj.file_type = "time_record";
    obj.nEtiqueta = [0];

    var type = await this.props.getDocumentType(obj.file_type);

    var document;
    if (type.print_type === "template") {
      document = await this.props.printDocumentTemplate(
        obj,
        type.print_automatically
      );
    } else if (type.print_type === "external") {
      document = await this.props.printDocumentExternal(
        obj,
        type.print_automatically
      );
    }

    if (document !== undefined) {
      this.props.waiting.handleClose();
      this.setState({ show: false });
    } else {
      this.props.waiting.handleClose();
    }
  }

  concatRH(text) {
    var resp = "";
    if (text !== null && text !== undefined) {
      var aux = text.split(" ");
      if (aux.length > 2) {
        resp =
          aux[0].length == 2 ? aux[0][0] + aux[1] + aux[0][1] : aux[0] + aux[1];
        if (aux[2] == "POSITIVO") resp += "+";
        else if (aux[2] == "NEGATIVO") resp += "-";
        else resp += "";
      } else {
        resp = aux[0];
        if (aux[1] == "POSITIVO") resp += "+";
        else if (aux[1] == "NEGATIVO") resp += "-";
        else resp += "";
      }
    }

    return resp;
  }

  async print_concent(e, item) {
    e.preventDefault();
    if (item.hc_status !== "") {
      this.waiting_modal.handleShow("Imprimiendo...");

      var obj = {};
      obj.health_facilities_id = parseInt(
        sessionStorage.getItem("health_facilities_id"),
        10
      );
      obj.id = item.offers_id;
      obj.file_type =
        item.extraction_name === "AF"
          ? "informed_consent_af"
          : item.extraction_name === "ST"
          ? "informed_consent_st"
          : item.extraction_name === "CEL"
          ? "informed_consent_cl"
          : "";
      obj.nEtiqueta = [0];

      var type = await this.props.getDocumentType(obj.file_type);

      if (type !== undefined) {
        var document;
        if (type.print_type === "template") {
          document = await this.props.printDocumentTemplate(
            obj,
            type.print_automatically
          );
        } else if (type.print_type === "external") {
          document = await this.props.printDocumentExternal(
            obj,
            type.print_automatically
          );
        }
      }

      this.waiting_modal.handleClose();
      if (document !== undefined) {
        this.setState({ show: false });
      }
    } else {
      swal("¡Error!", "Primero debe guardar la Historia Clínica", "error");
    }
  }

  async printAferesis(e, item) {
    e.preventDefault();
    if (item.ex_status !== "") {
      this.waiting_modal.handleShow("Imprimiendo...");

      var obj = {};
      obj.health_facilities_id = parseInt(
        sessionStorage.getItem("health_facilities_id"),
        10
      );
      obj.id = item.donation_id;
      obj.file_type = "apheresis_extraction";
      obj.nEtiqueta = [0];

      var type = await this.props.getDocumentType(obj.file_type);

      var document;
      if (type.print_type === "template") {
        document = await this.props.printDocumentTemplate(
          obj,
          type.print_automatically
        );
      } else if (type.print_type === "external") {
        document = await this.props.printDocumentExternal(
          obj,
          type.print_automatically
        );
      }

      if (document !== undefined) {
        this.waiting_modal.handleClose();
        this.setState({ show: false });
      } else {
        this.waiting_modal.handleClose();
      }
    } else {
      swal("¡Error!", "Primero debe guardar la Extracción", "error");
    }
  }

  openConfirmVitalSigns(id) {
    swal(
      {
        title: "Confirmar Toma de Signos Vitales",
        text: "",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "¡Si, Confirmar!",
        cancelButtonText: "¡No, Cancelar!",
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      async (isConfirm) => {
        if (isConfirm) {
          var response = await callerActionHistoryVitalSignsTaken(id);
          if (response !== undefined) {
          }
        }
      }
    );
  }

  //Contenido de la tabla
  render() {
    const { t } = this.props;
    const search =
      this.props.search !== ""
        ? this.props.search === this.props.match.url.replace("/", "")
          ? this.props.search
          : this.props.match.url.replace("/", "")
        : this.state.search;

    return (
      <div>
        <Table responsive hover>
          <thead>
            <tr>
              <th hidden={this.showColumn("ORIGIN")}>Centro</th>
              <th
                hidden={
                  search === "search_donor" || search === "promotion/offers"
                    ? true
                    : this.props.state.don_usr_llam.value === "NO_CALLER" ||
                      this.props.state.no_caller
                    ? true
                    : false
                }
                style={{ width: "135px" }}
              ></th>
              <th hidden={this.showColumn("CALLER_NUM")}>
                {t("content.offers.form.caller_number")}
              </th>
              <th hidden={this.showColumn("VITAL_SIGNS_TAKEN")}>SV Conf.</th>
              <th hidden={this.showColumn("STATUS")}>
                {t("content.offers.form.status")}
              </th>
              <th hidden={this.showColumn("DONATION_NUMBER")}>
                {t("content.offers.form.donation_number")}
              </th>
              <th hidden={this.showColumn("CAMPAING")}>Campaña</th>
              <th hidden={this.showColumn("OFFER_NUM")}>
                {t("content.offers.form.offers_num")}
              </th>
              <th hidden={this.showColumn("DONOR_ID")}>
                {t("content.offers.form.donor_id")}
              </th>
              <th hidden={this.showColumn("DONATION_TYPE")}>
                {t("content.offers.form.donation_type")}
              </th>
              <th hidden={this.showColumn("EXTRACTION_TYPE")}>
                {t("content.offers.form.extraction_type")}
              </th>
              <th hidden={this.showColumn("DONOR_NAME")}>
                {t("content.offers.form.donor_name")}
              </th>
              <th hidden={this.showColumn("PATIENT_NAME")}>Paciente</th>
              <th hidden={this.showColumn("GROUP_RH_INITIAL")}>
                Grupo & RH Inicial
              </th>
              <th hidden={this.showColumn("INVERSE_GROUP")}>Grupo Inverso</th>
              <th hidden={this.showColumn("GROUP_RH")}>
                {t("content.offers.form.group_rh")}
              </th>
              <th hidden={this.showColumn("REGISTER_DATE")}>
                {t("content.offers.form.timestamp")}
              </th>
              <th hidden={this.showColumn("EXTRACTION_DATE")}>
                {t("content.offers.form.date_extraction")}
              </th>
              <th hidden={this.showColumn("MEDICAL_STAFF")}>Medico</th>
              {this.props.state.offers.sections_color !== undefined
                ? this.props.state.offers.sections_color.map((s, i) => {
                    return <th key={i}>{s.lab_section_name}</th>;
                  })
                : null}
              <th hidden={this.showColumn("SV")}>
                {t("content.offers.form.sv")}
              </th>
              <th hidden={this.showColumn("BM")}>
                {t("content.offers.form.bm")}
              </th>
              <th hidden={this.showColumn("HC")}>
                {t("content.offers.form.hc")}
              </th>
              <th hidden={this.showColumn("EX")}>
                {t("content.offers.form.ex")}
              </th>
              <th hidden={this.showColumn("INC")}>
                {t("content.offers.form.inc")}
              </th>
              <th
                hidden={this.showColumn("REGISTER_LABEL")}
                style={{ paddingRight: "0px" }}
              >
                ET. REG.
              </th>
              <th
                hidden={this.showColumn("EXTRACTION_LABEL")}
                style={{ paddingRight: "0px" }}
              >
                ET. EXT.
              </th>
              <th
                hidden={this.showColumn("REFERENCE_DONORS")}
                style={{ paddingRight: "0px" }}
              >
                DOC. REF.
              </th>
              <th
                hidden={this.showColumn("DONATION_TICKET")}
                style={{ paddingRight: "0px" }}
              >
                COMP
              </th>
              <th
                hidden={this.showColumn("APHERESIS_DOCUMENT")}
                style={{ paddingRight: "0px", textAlign: "center" }}
              >
                AF
              </th>
              <th
                hidden={this.showColumn("TIME_RECORD")}
                style={{ paddingRight: "0px" }}
              >
                CONSTANCIA TIEMPO
              </th>
              <th
                hidden={this.showColumn("INFORMED_CONSENT")}
                style={{ paddingRight: "0px" }}
              >
                CONSENTIMIENTO
              </th>
              {search === "search_donor" ? <th>RESULTADO LAB.</th> : null}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {this.props.offers.res !== undefined &&
            this.props.offers.res !== null
              ? this.props.offers.res.map((item, index) =>
                  this.filter(item) === true ? (
                    <tr
                      key={index}
                      className={`
                        ${item.status === "REJECT" ? "danger" : ""}
                        ${item.priority === 1 ? 'high-priority': ""}
                      `}
                    >
                      <td hidden={this.showColumn("ORIGIN")}>{item.origin}</td>
                      <td
                        hidden={
                          search === "search_donor" ||
                          search === "promotion/offers"
                            ? true
                            : this.props.state.don_usr_llam.value ===
                                "NO_CALLER" || this.props.state.no_caller
                            ? true
                            : false
                        }
                      >
                        {search !== "offers" ? (
                          <FloatingActionButton
                            backgroundColor={"#ededed"}
                            iconStyle={{ height: 33, width: 33 }}
                            mini={true}
                            style={{ marginLeft: "5px" }}
                            title={
                              item.caller !== null
                                ? item.caller.section +
                                  " | " +
                                  (item.caller.machine_name !== null
                                    ? item.caller.machine_name.split("|")[1]
                                    : "")
                                : ""
                            }
                            onClick={(e) => this.caller(item.caller.id)}
                            disabled={
                              item.caller !== null
                                ? item.caller.machine_ip !== null
                                : true
                            }
                          >
                            {item.caller !== null ? (
                              item.caller.section === "REGISTRO" ? (
                                <SvgIcon
                                  icon={ic_assignment_ind}
                                  className="icon-align"
                                />
                              ) : item.caller.section === "SIGNOS VITALES" ? (
                                <IconSV style={{ width: "20px" }} />
                              ) : item.caller.section ===
                                "BIOMETRÍA HEMÁTICA" ? (
                                <IconBio style={{ width: "20px" }} />
                              ) : item.caller.section === "EXTRACCIÓN" ? (
                                <IconEx style={{ width: "20px" }} />
                              ) : item.caller.section === "HISTORIA CLÍNICA" ? (
                                <IconHC style={{ width: "20px" }} />
                              ) : (
                                <SvgIcon
                                  icon={volumeHigh}
                                  className="icon-align"
                                />
                              )
                            ) : (
                              <SvgIcon
                                icon={volumeHigh}
                                className="icon-align"
                              />
                            )}
                          </FloatingActionButton>
                        ) : null}

                        <FloatingActionButton
                          backgroundColor={"#ededed"}
                          iconStyle={{ height: 33, width: 33 }}
                          mini={true}
                          style={{ marginLeft: "5px" }}
                          onClick={(e) => this.releaseCaller(item.caller.id)}
                          disabled={
                            item.caller !== null
                              ? item.caller.machine_ip !== null
                                ? search === "offers"
                                  ? false
                                  : item.caller.machine_ip ==
                                    sessionStorage.getItem("ip")
                                  ? false
                                  : true
                                : true
                              : true
                          }
                        >
                          <SvgIcon icon={volumeMute2} className="icon-align" />
                        </FloatingActionButton>
                        {item.caller !== null && (
                          <FloatingActionButton
                            backgroundColor={"#ededed"}
                            iconStyle={{ height: 33, width: 33 }}
                            title="Etiqueta llamador"
                            mini={true}
                            style={{ marginLeft: "5px" }}
                            onClick={this.openModalLabel.bind(
                              this,
                              "label_caller",
                              item.caller.id,
                              null,
                              true
                            )}
                          >
                            <SvgIcon icon={priceTag} className="icon-align" />
                          </FloatingActionButton>
                        )}
                      </td>
                      <td hidden={this.showColumn("CALLER_NUM")}>
                        {item.caller != null ? item.caller.record_number : null}
                      </td>
                      <td hidden={this.showColumn("VITAL_SIGNS_TAKEN")}>
                        {item.offers_id === "" ? (
                          item.caller !== null ? (
                            item.caller.vital_signs_taken ? (
                              "SI"
                            ) : (
                              <FloatingActionButton
                                backgroundColor={"#ededed"}
                                iconStyle={{ height: 33, width: 33 }}
                                title="Confirmar Toma de Signos Vitales"
                                mini={true}
                                disabled={
                                  item.caller !== null
                                    ? item.caller.machine_ip !== null
                                      ? search === "offers"
                                        ? false
                                        : item.caller.machine_ip ==
                                          sessionStorage.getItem("ip")
                                        ? false
                                        : true
                                      : true
                                    : true
                                }
                                onClick={() =>
                                  this.openConfirmVitalSigns(item.caller.id)
                                }
                              >
                                <SvgIcon icon={cross} className="icon-align" />
                              </FloatingActionButton>
                            )
                          ) : null
                        ) : null}
                      </td>
                      <td hidden={this.showColumn("STATUS")}>
                        {item.caller != null ? item.caller.status : null}
                      </td>
                      <td hidden={this.showColumn("DONATION_NUMBER")}>
                        {item != null ? item.donation_number : null}
                      </td>
                      <td hidden={this.showColumn("CAMPAING")}>
                        {item !== null ? item.campaing : ""}
                      </td>
                      <td hidden={this.showColumn("OFFER_NUM")}>
                        {item != null ? item.offers_id : null}
                      </td>
                      <td hidden={this.showColumn("DONOR_ID")}>
                        {item != null ? item.donor_number : null}
                      </td>
                      <td hidden={this.showColumn("DONATION_TYPE")}>
                        {item != null ? item.donation_name : null}
                      </td>
                      <td hidden={this.showColumn("EXTRACTION_TYPE")}>
                        {item != null ? item.extraction_name : null}
                      </td>
                      <td
                        hidden={this.showColumn("DONOR_NAME")}
                        className="color-font"
                      >
                        {item != null ? item.donor_name : null}
                      </td>
                      <td
                        hidden={this.showColumn("PATIENT_NAME")}
                        className="color-font"
                      >
                        {item != null ? item.patient : null}
                      </td>
                      <td
                        hidden={this.showColumn("GROUP_RH_INITIAL")}
                        align="center"
                      >
                        {item != null ? (
                          <a
                            href="#"
                            onClick={
                              item.validated
                                ? (e) => e.preventDefault()
                                : item.caller !== null
                                ? item.caller.machine_ip !== null
                                  ? item.caller.machine_ip ==
                                    sessionStorage.getItem("ip")
                                    ? (e) =>
                                        this.openModalGrupoRH(
                                          e,
                                          item,
                                          item.group_test_id,
                                          item.group_test_value,
                                          item.caller,
                                          "initial"
                                        )
                                    : (e) => e.preventDefault()
                                  : (e) =>
                                      this.openModalGrupoRH(
                                        e,
                                        item,
                                        item.group_test_id,
                                        item.group_test_value,
                                        item.caller,
                                        "initial"
                                      )
                                : (e) =>
                                    this.openModalGrupoRH(
                                      e,
                                      item,
                                      item.group_test_id,
                                      item.group_test_value,
                                      item.caller,
                                      "initial"
                                    )
                            }
                            className={
                              item.validated
                                ? "disabled"
                                : search === "offers"
                                ? ""
                                : item.caller !== null
                                ? item.caller.machine_ip !== null
                                  ? item.caller.machine_ip ==
                                    sessionStorage.getItem("ip")
                                    ? ""
                                    : "disabled"
                                  : ""
                                : ""
                            }
                          >
                            {item.group_test_value === null ||
                            item.group_test_value === " " ? (
                              <SvgIcon
                                size={25}
                                icon={droplet}
                                title="Grupo & RH"
                              />
                            ) : (
                              this.concatRH(item.group_test_value)
                            )}
                          </a>
                        ) : null}
                      </td>
                      <td
                        hidden={this.showColumn("INVERSE_GROUP")}
                        align="center"
                      >
                        {item != null ? (
                          <a
                            href="#"
                            onClick={
                              item.validated
                                ? (e) => e.preventDefault()
                                : item.caller !== null
                                ? item.caller.machine_ip !== null
                                  ? item.caller.machine_ip ==
                                    sessionStorage.getItem("ip")
                                    ? (e) =>
                                        this.openModalGrupoRH(
                                          e,
                                          item,
                                          item.group_test_id,
                                          item.inverse_group_id,
                                          item.caller,
                                          "inverso"
                                        )
                                    : (e) => e.preventDefault()
                                  : (e) =>
                                      this.openModalGrupoRH(
                                        e,
                                        item,
                                        item.inverse_group_id,
                                        item.inverse_group,
                                        item.caller,
                                        "inverso"
                                      )
                                : (e) =>
                                    this.openModalGrupoRH(
                                      e,
                                      item,
                                      item.inverse_group_id,
                                      item.inverse_group,
                                      item.caller,
                                      "inverso"
                                    )
                            }
                            className={
                              item.validated
                                ? "disabled"
                                : search === "offers"
                                ? ""
                                : item.caller !== null
                                ? item.caller.machine_ip !== null
                                  ? item.caller.machine_ip ==
                                    sessionStorage.getItem("ip")
                                    ? ""
                                    : "disabled"
                                  : ""
                                : ""
                            }
                          >
                            {item.inverse_group_id === null ? (
                              <SvgIcon
                                size={25}
                                icon={droplet}
                                title="Grupo Inverso"
                              />
                            ) : (
                              item.inverse_group
                            )}
                          </a>
                        ) : null}
                      </td>
                      <td hidden={this.showColumn("GROUP_RH")} align="center">
                        {this.concatRH(item.group_rh)}
                      </td>
                      <td hidden={this.showColumn("REGISTER_DATE")}>
                        {item != null ? (
                          <div>
                            {this.state.today !== this.props.filterDate ? (
                              item.timestamp_date !== "" &&
                              item.timestamp_date !== null ? (
                                <div>
                                  <Moment format="DD/MM/YYYY">
                                    {item.timestamp_date}
                                  </Moment>{" "}
                                </div>
                              ) : (
                                ""
                              )
                            ) : null}

                            {item.timestamp_hour !== "" &&
                            item.timestamp_hour !== null
                              ? moment(item.timestamp_hour, "H:mm:ss").format(
                                  "HH:mm"
                                ) !== "Invalid date"
                                ? moment(item.timestamp_hour, "H:mm:ss").format(
                                    "HH:mm"
                                  )
                                : null
                              : ""}
                          </div>
                        ) : null}
                      </td>
                      <td hidden={this.showColumn("EXTRACTION_DATE")}>
                        {item != null ? (
                          <div>
                            {item.extraction_date !== null &&
                            item.extraction_date !== "" ? (
                              <div>
                                <Moment format="DD/MM/YYYY">
                                  {item.extraction_date}
                                </Moment>{" "}
                              </div>
                            ) : null}
                            {item.extraction_hour !== null &&
                            item.extraction_hour !== ""
                              ? moment(item.extraction_hour, "H:mm:ss").format(
                                  "HH:mm"
                                ) !== "Invalid date"
                                ? moment(
                                    item.extraction_hour,
                                    "H:mm:ss"
                                  ).format("HH:mm")
                                : null
                              : null}
                          </div>
                        ) : null}
                      </td>
                      <td hidden={this.showColumn("MEDICAL_STAFF")}>
                        {item.medical_staff}
                      </td>

                      {this.props.state.offers.sections_color !== undefined
                        ? this.props.state.offers.sections_color.map((s, i) => {
                            return (
                              <td key={i}>
                                <a
                                  href=""
                                  title={s.name}
                                  onClick={(e) =>
                                    this.singleValidation(e, s, item)
                                  }
                                  style={{ color: s.color }}
                                >
                                  <SvgIcon size={25} icon={clipboard} />
                                </a>
                              </td>
                            );
                          })
                        : null}

                      <td hidden={this.showColumn("SV")}>
                        {item !== null ? (
                          /*<a href="" style={{color:item.sv_status}} */

                          <FloatingActionButton
                            backgroundColor={"#ededed"}
                            title="Signos Vitales"
                            mini={true}
                            className={
                              item.has_sv_incicent ? "with-incident" : ""
                            }
                            onClick={(e) =>
                              this.openModalVitalSigns(
                                e,
                                item.offers_id,
                                item.donor_id,
                                item.caller,
                                item
                              )
                            }
                            disabled={
                              item.offers_id === ""
                                ? true
                                : item.ExternalType
                                ? true
                                : !this.props.task_vital_signs.read
                                ? true
                                : search !== "offers"
                                ? item.caller !== null
                                  ? item.caller.machine_ip !== null
                                    ? item.caller.machine_ip ==
                                      sessionStorage.getItem("ip")
                                      ? false
                                      : true
                                    : false //item.sv_status === "" ? true : false
                                  : false
                                : false
                            }
                          >
                            {/*<SvgIcon size={25} icon={stethoscope} title="Signos Vitales" style={{color:item.sv_status}}/>*/}
                            <IconSV
                              width={30}
                              title="Signos Vitales"
                              fill={
                                //item.has_sv_incicent ? 'red' :
                                item.sv_status === "INCOMPLETE"
                                  ? "var(--color-partial-data)"
                                  : item.sv_status === "COMPLETE"
                                  ? "var(--color-data)"
                                  : "var(--color-no-data)"
                              }
                            />
                          </FloatingActionButton>
                        ) : null}
                      </td>
                      <td hidden={this.showColumn("BM")}>
                        {item !== null ? (
                          <FloatingActionButton
                            backgroundColor={"#ededed"}
                            className={
                              item.sample_valid === null
                                ? ""
                                : !item.sample_valid
                                ? "with-incident"
                                : "without-incident"
                            }
                            title="Biometría Hemática"
                            mini={true}
                            onClick={
                              this.state.don_hue_dig.value === "YES" &&
                              this.state.don_bh_hue_dig.value === "YES"
                                ? //(e) => this.openModalBiometrics(e,item.offers_id,item.donor_id, item.caller)
                                  this.state.print_tickets.value === "YES"
                                  ? (e) =>
                                      this.openModalHueBH(
                                        e,
                                        item,
                                        item.caller,
                                        item.hc_status,
                                        item.status
                                      )
                                  : (e) =>
                                      this.openModalHueBH(
                                        e,
                                        item,
                                        item.caller,
                                        item.hc_status,
                                        item.status
                                      )
                                : //(e) => this.openModalBiometrics(e,item.offers_id,item.donor_id, item.caller)
                                  (e) =>
                                    this.openModalBiometrics(
                                      e,
                                      item.offers_id,
                                      item.donor_id,
                                      item.caller,
                                      item
                                    )
                            }
                            //onClick={(e) => this.openModalBiometrics(e,item.offers_id,item.donor_id, item.caller)}
                            disabled={
                              item.ExternalType
                                ? true
                                : !this.props.task_biometrics.read
                                ? true
                                : search !== "offers"
                                ? item.caller !== null
                                  ? item.caller.machine_ip !== null
                                    ? item.caller.machine_ip ==
                                      sessionStorage.getItem("ip")
                                      ? false
                                      : true
                                    : false //item.bio_status === "" ? true : false
                                  : false
                                : false
                            }
                          >
                            {/*<SvgIcon size={30} icon={iosSpeedometer} title="Biométricos" style={{color:item.bio_status}}/>*/}

                            <IconBio
                              width={30}
                              title="Biometría Hemática"
                              fill={
                                //item.has_bio_incicent ? "red" :
                                item.bio_status === "INCOMPLETE"
                                  ? "var(--color-partial-data)"
                                  : item.bio_status === "COMPLETE"
                                  ? "var(--color-data)"
                                  : "var(--color-no-data)"
                              }
                            />
                          </FloatingActionButton>
                        ) : null}
                      </td>
                      {/*this.props.task_clinic_history.read?*/}
                      <td hidden={this.showColumn("HC")}>
                        {item !== null ? (
                          <FloatingActionButton
                            backgroundColor={"#ededed"}
                            title="Historia Clínica"
                            mini={true}
                            onClick={
                              this.state.don_hue_dig.value === "YES" &&
                              this.state.don_hc_hue_dig.value === "YES" &&
                              item.donation_id === 0
                                ? (e) =>
                                    this.openModalHueHC(
                                      e,
                                      item,
                                      item.caller,
                                      item.hc_status,
                                      item.status
                                    )
                                : (e) => this.openModalHC(e, item, item.caller)
                            }
                            disabled={
                              item.ExternalType
                                ? true
                                : !this.props.task_clinic_history.read
                                ? true
                                : search !== "offers"
                                ? item.caller !== null
                                  ? item.caller.machine_ip !== null
                                    ? item.caller.machine_ip ==
                                      sessionStorage.getItem("ip")
                                      ? false
                                      : true
                                    : false
                                  : false
                                : false
                            }
                          >
                            <IconHC
                              width={30}
                              title="Historia Clínica"
                              fill={
                                item.hc_status === "INCOMPLETE"
                                  ? "var(--color-partial-data)"
                                  : item.hc_status === "COMPLETE"
                                  ? "var(--color-data)"
                                  : "var(--color-no-data)"
                              }
                            />
                          </FloatingActionButton>
                        ) : null}
                      </td>
                      {/*:null
                       */}
                      <td hidden={this.showColumn("EX")}>
                        {this.props.task_extraction.create}
                        {item !== null ? (
                          this.state.don_hue_dig.value === "YES" &&
                          this.state.don_hue_ext.value === "YES" &&
                          item.donation_id === 0 ? (
                            <FloatingActionButton
                              backgroundColor={"#ededed"}
                              title="Extracción"
                              mini={true}
                              className={
                                item.extraction_incident_id !== 0
                                  ? "with-incident"
                                  : ""
                              }
                              disabled={
                                item.ExternalType
                                  ? false
                                  : item.hc_status === "" ||
                                    item.hc_status === "INCOMPLETE"
                                  ? true
                                  : item.status === "REJECT" &&
                                    item.ex_status === ""
                                  ? true
                                  : !this.props.task_extraction.create ||
                                    !this.props.task_extraction.update
                                  ? true
                                  : search !== "offers"
                                  ? item.caller !== null
                                    ? item.caller.machine_ip !== null
                                      ? item.caller.machine_ip ==
                                        sessionStorage.getItem("ip")
                                        ? false
                                        : true
                                      : false
                                    : false
                                  : false
                              }
                              onClick={(e) =>
                                this.openModalExtraction(
                                  e,
                                  item,
                                  item.caller,
                                  item.hc_status,
                                  item.status
                                )
                              }
                            >
                              {/*<SvgIcon size={30} icon={u1F489} title="Extracción" style={{color:item.ex_color}} />*/}
                              <IconEx
                                width={30}
                                title="Extracción"
                                fill={
                                  item.ex_status === "INCOMPLETE"
                                    ? "var(--color-partial-data)"
                                    : item.ex_status === "COMPLETE"
                                    ? "var(--color-data)"
                                    : "var(--color-no-data)"
                                }
                              />
                            </FloatingActionButton>
                          ) : (
                            <FloatingActionButton
                              backgroundColor={"#ededed"}
                              title="Extracción"
                              mini={true}
                              className={
                                item.extraction_incident_id !== 0
                                  ? "with-incident"
                                  : ""
                              }
                              disabled={
                                item.ExternalType
                                  ? false
                                  : item.hc_status === "" ||
                                    item.hc_status === "INCOMPLETE"
                                  ? true
                                  : item.status === "REJECT" &&
                                    item.ex_status === ""
                                  ? true
                                  : !this.props.task_extraction.create ||
                                    !this.props.task_extraction.update
                                  ? true
                                  : item.caller !== null
                                  ? item.caller.machine_ip !== null
                                    ? item.caller.machine_ip ==
                                      sessionStorage.getItem("ip")
                                      ? false
                                      : true
                                    : false
                                  : false
                              }
                              onClick={(e) =>
                                this.goToEX(
                                  e,
                                  item,
                                  item.caller,
                                  item.hc_status,
                                  item.status
                                )
                              }
                            >
                              {/*<SvgIcon size={30} icon={u1F489} title="Extracción" style={{color:item.ex_color}}/>*/}
                              <IconEx
                                width={30}
                                title="Extracción"
                                fill={
                                  item.ex_status === "INCOMPLETE"
                                    ? "var(--color-partial-data)"
                                    : item.ex_status === "COMPLETE"
                                    ? "var(--color-data)"
                                    : "var(--color-no-data)"
                                }
                              />
                            </FloatingActionButton>
                          )
                        ) : null}
                      </td>
                      <td hidden={this.showColumn("INC")}>
                        {item !== null ? (
                          <FloatingActionButton
                            backgroundColor={
                              item.extraction_incident_id !== 0
                                ? "#ffffff"
                                : "#ededed"  
                            }
                            title="Incidentes Extracción"
                            mini={true}
                            onClick={(e) => this.openModalIncidents(e, item)}
                            disabled={
                              search !== "offers"
                                ? item.caller !== null
                                  ? item.caller.machine_ip !== null
                                    ? item.caller.machine_ip ==
                                      sessionStorage.getItem("ip")
                                      ? false
                                      : true
                                    : item.hc_status === ""
                                    ? true
                                    : false
                                  : false
                                : false
                            }
                          >
                            {/*<SvgIcon size={30} icon={lock} title="Incidentes Extracción" style={{color:'#333'}}/>*/}
                            <IconInc
                              width={30}
                              title="Incidentes Extracción"
                              fill={
                                item.extraction_incident_id !== 0
                                ? "#a31196"
                                : "#8f90b2"  
                              }
                            />
                          </FloatingActionButton>
                        ) : null}
                      </td>

                      <td
                        hidden={this.showColumn("REGISTER_LABEL")}
                        style={{ paddingRight: "0px" }}
                      >
                        {item !== null ? (
                          <FloatingActionButton
                            backgroundColor={"#ededed"}
                            iconStyle={{ height: 33, width: 33 }}
                            title="Registro"
                            mini={true}
                            style={{ marginLeft: "5px" }}
                            disabled={item.offers_id === ""}
                            onClick={this.openModalLabel.bind(
                              this,
                              "label_register",
                              item.offers_id,
                              null,
                              true
                            )}
                          >
                            <SvgIcon icon={priceTag} className="icon-align" />
                          </FloatingActionButton>
                        ) : null}
                      </td>
                      <td
                        hidden={this.showColumn("EXTRACTION_LABEL")}
                        style={{ paddingRight: "0px" }}
                      >
                        {item !== null ? (
                          <FloatingActionButton
                            backgroundColor={"#ededed"}
                            iconStyle={{ height: 33, width: 33 }}
                            disabled={
                              item.donation_id === 0 || item.donation_id === ""
                                ? true
                                : false
                            }
                            title="Extracción"
                            mini={true}
                            style={{ marginLeft: "5px" }}
                            onClick={this.openModalLabel.bind(
                              this,
                              "label_extraction",
                              item.donation_id,
                              item.extraction_name,
                              true
                            )}
                          >
                            <SvgIcon
                              icon={priceTag}
                              className={
                                item.donation_id === 0 ||
                                item.donation_id === ""
                                  ? ""
                                  : "icon-align"
                              }
                              style={{ color: "#aeabab" }}
                            />
                          </FloatingActionButton>
                        ) : null}
                      </td>
                      <td
                        hidden={this.showColumn("REFERENCE_DONORS")}
                        style={{ paddingRight: "0px" }}
                      >
                        {item !== null ? (
                          <FloatingActionButton
                            backgroundColor={"#ededed"}
                            iconStyle={{ height: 33, width: 33 }}
                            title="Documento Referencia"
                            mini={true}
                            style={{ marginLeft: "5px" }}
                            onClick={(e) =>
                              this.printDocument(e, item.offers_id)
                            }
                          >
                            <SvgIcon
                              icon={fileText}
                              className={"icon-align"}
                              style={{ color: "#aeabab" }}
                            />
                          </FloatingActionButton>
                        ) : null}
                      </td>

                      <td
                        hidden={this.showColumn("DONATION_TICKET")}
                        style={{ paddingRight: "0px" }}
                      >
                        {item !== null ? (
                          <FloatingActionButton
                            backgroundColor={"#ededed"}
                            iconStyle={{ height: 33, width: 33 }}
                            disabled={
                              item.hc_status === "COMPLETE" &&
                              item.status !== "REJECT"
                                ? false
                                : true
                            }
                            title="Comprobante Donación"
                            mini={true}
                            style={{ marginLeft: "5px" }}
                            onClick={(e) =>
                              this.printDonationTicket(
                                e,
                                item.offers_id,
                                item.donation_ticket,
                                item.donation_number
                              )
                            }
                          >
                            <SvgIcon
                              icon={fileText}
                              className={
                                item.hc_status === "COMPLETE"
                                  ? "icon-align"
                                  : ""
                              }
                              style={{ color: "#aeabab" }}
                            />
                          </FloatingActionButton>
                        ) : null}
                      </td>
                      <td
                        hidden={this.showColumn("APHERESIS_DOCUMENT")}
                        style={{ paddingRight: "0px", textAlign: "center" }}
                      >
                        {item.extraction_name !== "ST" && (
                          <FloatingActionButton
                            backgroundColor={"#ededed"}
                            iconStyle={{ height: 33, width: 33 }}
                            title={"Aféresis"}
                            mini={true}
                            disabled={item.status === ""}
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => this.printAferesis(e, item)}
                          >
                            <SvgIcon icon={print} className="icon-align" />
                          </FloatingActionButton>
                        )}
                      </td>
                      <td
                        hidden={this.showColumn("TIME_RECORD")}
                        style={{ paddingRight: "0px" }}
                      >
                        <FloatingActionButton
                          backgroundColor={"#ededed"}
                          iconStyle={{ height: 33, width: 33 }}
                          title="Constancia de Tiempo"
                          mini={true}
                          style={{ marginLeft: "5px" }}
                          onClick={(e) => this.print_time_record(e, item)}
                        >
                          <SvgIcon icon={printer} className="icon-align" />
                        </FloatingActionButton>
                      </td>
                      <td
                        hidden={this.showColumn("INFORMED_CONSENT")}
                        style={{ paddingRight: "0px" }}
                      >
                        <FloatingActionButton
                          backgroundColor={"#ededed"}
                          iconStyle={{ height: 33, width: 33 }}
                          title={t("toolbar.print_con")}
                          mini={true}
                          disabled={item.hc_status === ""}
                          style={{ marginLeft: "5px" }}
                          onClick={(e) => this.print_concent(e, item)}
                        >
                          <SvgIcon icon={print} className="icon-align" />
                        </FloatingActionButton>
                      </td>

                      {search === "search_donor" ? (
                        <td style={{ textAlign: "center" }}>
                          <FloatingActionButton
                            backgroundColor={"#ededed"}
                            iconStyle={{ height: 33, width: 33 }}
                            disabled={
                              item.hc_status === "COMPLETE" ? false : true
                            }
                            title="Imprimir Resultados"
                            mini={true}
                            style={{ marginLeft: "5px" }}
                            onClick={(e) => this.laboratory_print(e, item)}
                          >
                            <SvgIcon icon={printer} className="icon-align" />
                          </FloatingActionButton>
                        </td>
                      ) : null}
                      <td
                        width={
                          search === "register" ||
                          this.props.state.show_promotion
                            ? 160
                            : 100
                        }
                      >
                        {item !== null ? (
                          item.offers_id !== "" ? (
                            <div>
                              {search === "social" ||
                              this.props.state.show_promotion ? (
                                <FloatingActionButton
                                  backgroundColor={"#ededed"}
                                  iconStyle={{ height: 33, width: 33 }}
                                  title="Cuestionario"
                                  mini={true}
                                  style={{ marginLeft: "5px" }}
                                  onClick={(e) =>
                                    this.openModalSocial(
                                      e,
                                      item.offers_id,
                                      item.donor_id,
                                      item.caller,
                                      item.donor_name
                                    )
                                  }
                                  disabled={
                                    search === "register"
                                      ? !this.props.task_register.update
                                      : !this.props.task_summary_campaigns
                                          .update
                                  }
                                >
                                  <SvgIcon
                                    icon={fileText}
                                    className="icon-align"
                                  />
                                </FloatingActionButton>
                              ) : null}
                              {search != "social" ||
                              this.props.state.show_promotion ? (
                                <FloatingActionButton
                                  backgroundColor={"#ededed"}
                                  iconStyle={{ height: 33, width: 33 }}
                                  title="Detalles"
                                  mini={true}
                                  style={{ marginLeft: "5px" }}
                                  onClick={
                                    (e) =>
                                      this.openViewDetails(
                                        e,
                                        item,
                                        item.caller
                                      ) /*openViewDetails(e,item.caller)*/
                                  }
                                  disabled={
                                    this.props.state.show_promotion
                                      ? !this.props.task_summary_campaigns
                                          .update
                                      : !this.props.task_register.read
                                  }
                                >
                                  <SvgIcon icon={eye} className="icon-align" />
                                </FloatingActionButton>
                              ) : null}
                              {search === "register" ||
                              this.props.state.show_promotion ? (
                                <FloatingActionButton
                                  backgroundColor={"#ededed"}
                                  iconStyle={{ height: 33, width: 33 }}
                                  title="Editar"
                                  mini={true}
                                  style={{ marginLeft: "5px" }}
                                  onClick={(e) => this.editRegister(e, item)}
                                  disabled={
                                    search === "register"
                                      ? !this.props.task_register.update
                                      : !this.props.task_summary_campaigns
                                          .update
                                  }
                                >
                                  <SvgIcon
                                    icon={pencil}
                                    className="icon-align"
                                  />
                                </FloatingActionButton>
                              ) : null}

                              <FloatingActionButton
                                backgroundColor={"#ededed"}
                                iconStyle={{ height: 33, width: 33 }}
                                title="Eliminar"
                                mini={true}
                                style={{ marginLeft: "5px" }}
                                onClick={this.deleteMsg.bind(
                                  this,
                                  item,
                                  this.props
                                )}
                                disabled={
                                  search === "extractions"
                                    ? item.caller !== null
                                      ? item.caller.machine_ip !== null
                                        ? item.caller.machine_ip ==
                                          sessionStorage.getItem("ip")
                                          ? false
                                          : true
                                        : this.props.task_extraction.delete
                                        ? false
                                        : true
                                      : !this.props.task_extraction.delete
                                    : search === "vital_signs"
                                    ? item.caller !== null
                                      ? item.caller.machine_ip !== null
                                        ? item.caller.machine_ip ==
                                          sessionStorage.getItem("ip")
                                          ? false
                                          : true
                                        : this.props.task_vital_signs.delete
                                        ? false
                                        : true
                                      : !this.props.task_vital_signs.delete
                                    : search === "clinic_history"
                                    ? item.caller !== null
                                      ? item.caller.machine_ip !== null
                                        ? item.caller.machine_ip ==
                                          sessionStorage.getItem("ip")
                                          ? false
                                          : true
                                        : this.props.task_clinic_history.delete
                                        ? false
                                        : true
                                      : !this.props.task_clinic_history.delete
                                    : search === "biometrics"
                                    ? item.caller !== null
                                      ? item.caller.machine_ip !== null
                                        ? item.caller.machine_ip ==
                                          sessionStorage.getItem("ip")
                                          ? false
                                          : true
                                        : this.props.task_biometrics.delete
                                        ? false
                                        : true
                                      : !this.props.task_biometrics.delete
                                    : search === "offers"
                                    ? !this.props.task_general_summary.delete
                                    : search === "register"
                                    ? item.caller !== null
                                      ? item.caller.machine_ip !== null
                                        ? item.caller.machine_ip ==
                                          sessionStorage.getItem("ip")
                                          ? false
                                          : true
                                        : this.props.task_register.delete
                                        ? false
                                        : true
                                      : !this.props.task_register.delete
                                    : this.state.show_promotion
                                    ? !this.props.task_summary_campaigns.delete
                                    : item.caller !== null
                                    ? item.caller.machine_ip !== null
                                      ? item.caller.machine_ip ==
                                        sessionStorage.getItem("ip")
                                        ? false
                                        : true
                                      : item.caller.machine_ip === null
                                      ? false
                                      : true
                                    : false
                                  //: false
                                }
                              >
                                <SvgIcon icon={bin} className="icon-align" />
                              </FloatingActionButton>
                            </div>
                          ) : (
                            <div>
                              {search !== "vital_signs" && (
                                <FloatingActionButton
                                  backgroundColor={"#ededed"}
                                  iconStyle={{ height: 33, width: 33 }}
                                  disabled={
                                    search === "register"
                                      ? !this.props.task_register.create
                                        ? true
                                        : item.caller !== null
                                        ? item.caller.machine_ip !== null
                                          ? item.caller.machine_ip ==
                                            sessionStorage.getItem("ip")
                                            ? false
                                            : true
                                          : item.caller.machine_ip === null
                                          ? true
                                          : false
                                        : false
                                      : search === "offers"
                                      ? !this.props.task_general_summary.create
                                      : false
                                  }
                                  onClick={(e) =>
                                    this.openRegister(e, item.caller)
                                  }
                                  mini={true}
                                >
                                  <ContentAdd className="icon-align" />
                                </FloatingActionButton>
                              )}
                              <FloatingActionButton
                                backgroundColor={"#ededed"}
                                iconStyle={{ height: 33, width: 33 }}
                                disabled={
                                  search === "register"
                                    ? //!this.props.task_register.delete ?
                                      !this.props.task_screen_caller.delete
                                      ? true
                                      : item.caller !== null
                                      ? item.caller.machine_ip !== null
                                        ? item.caller.machine_ip ==
                                          sessionStorage.getItem("ip")
                                          ? false
                                          : true
                                        : item.caller.machine_ip === null
                                        ? false
                                        : true
                                      : false
                                    : search === "offers"
                                    ? !this.props.task_general_summary.delete
                                    : false
                                }
                                mini={true}
                                style={{ marginLeft: "5px" }}
                                onClick={(e) =>
                                  this.preRegisterIncident(e, item.caller)
                                }
                              >
                                <ContentRemove className="icon-align" />
                              </FloatingActionButton>
                            </div>
                          )
                        ) : null}
                      </td>
                    </tr>
                  ) : null
                )
              : null}
          </tbody>
        </Table>

        <ModalIncidents
          {...this.props}
          onRef={(ref) => (this.modal_incidents = ref)}
          refresh={
            search === "search_donor" ? this.refreshDonor : this.props.refresh
          }
        />
        <ModalPreRegisterIncident
          {...this.props}
          onRef={(ref) => (this.modal_incident = ref)}
          refresh={
            search === "search_donor" ? this.refreshDonor : this.props.refresh
          }
        />
        <ModalGrupoRH
          {...this.props}
          onRef={(ref) => (this.modal_grupo_rh = ref)}
          refresh={
            search === "search_donor" ? this.refreshDonor : this.props.refresh
          }
        />
        <ModalVitalSigns
          {...this.props}
          onRef={(ref) => (this.modal_vital_signs = ref)}
          refresh={
            search === "search_donor" ? this.refreshDonor : this.props.refresh
          }
        />
        <ModalSocial
          {...this.props}
          search={this.props.search}
          onRef={(ref) => (this.modal_social = ref)}
        />
        <ModalBiometrics
          {...this.props}
          onRef={(ref) => (this.modal_biometrics = ref)}
          refresh={
            search === "search_donor" ? this.refreshDonor : this.props.refresh
          }
        />
        <ModalExtraction
          {...this.props}
          onRef={(ref) => (this.modal_extractions = ref)}
          refresh={
            search === "search_donor" ? this.refreshDonor : this.props.refresh
          }
        />
        <WaitingModal
          {...this.props}
          onRef={(ref) => (this.waiting_modal = ref)}
        />
        <ModalViewInformation
          {...this.props}
          onRef={(ref) => (this.modal_view_information = ref)}
          refresh={
            search === "search_donor" ? this.refreshDonor : this.props.refresh
          }
        />
        <ModalPrintLabel
          {...this.props}
          onRef={(ref) => (this.modal_print_label = ref)}
          directPrint={this.directPrint}
        />
        <ModalSingleValidation
          {...this.props}
          onRef={(ref) => (this.single_validation = ref)}
          refresh={this.refreshDonor}
          state={this.props.state}
        />
      </div>
    );
  }
}

export default translate("translations")(TableOffers);
